var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShearsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49074 4.66659C5.80743 4.31275 6 3.84549 6 3.33325C6 2.22869 5.10457 1.33325 4 1.33325C2.89543 1.33325 2 2.22869 2 3.33325C2 4.43782 2.89543 5.33325 4 5.33325C4.59233 5.33325 5.12453 5.07575 5.49074 4.66659ZM5.49074 4.66659L14 11.9999M5.49074 11.3333C5.80743 11.6871 6 12.1543 6 12.6666C6 13.7712 5.10457 14.6666 4 14.6666C2.89543 14.6666 2 13.7712 2 12.6666C2 11.562 2.89543 10.6666 4 10.6666C4.59233 10.6666 5.12453 10.9241 5.49074 11.3333ZM5.49074 11.3333L14 3.99992",
    stroke: "#001535",
    strokeOpacity: 0.3,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShearsIcon);
export default __webpack_public_path__ + "static/media/shearsIcon.363c35f0713e0d2b5b673927e1da8803.svg";
export { ForwardRef as ReactComponent };